import React from 'react';
import {View} from 'react-native';

import {withSafeArea} from '/provider/SafeAreaProvider';

import {styles} from './BasicHeader.style';

export interface BasicHeaderProps {
  // eslint-disable-next-line react/require-default-props
  children?: React.ReactNode;
  safeAreaInsets: {
    top: number;
    right: number;
    bottom: number;
    left: number;
  };
}

export const BasicHeader: React.FC<BasicHeaderProps> = ({
  children = null,
  safeAreaInsets = withSafeArea.safeAreaInsetsDefaultProp,
}) => {
  const style = [styles.base, {paddingTop: safeAreaInsets.top}];

  return <View style={style}>{children}</View>;
};

export default withSafeArea(BasicHeader);
